import React, { useId, useMemo } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { FILE_STORAGE_SERVER_URL } from "../../helpers/constants";
import { Tooltip } from "react-tooltip";

import clsx from "clsx";
import { MdAccountBox } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useCollapsibles from "../../hooks/useCollapsibles";
import useModalsStore from "src/store/modalsStore";
import { motion } from "framer-motion";
import useMobile from "src/hooks/useMobile";

const CurrentUserCardInfo = () => {
  const { t } = useTranslation();
  const tooltipId = useId();
  const { isMobile } = useMobile();
  const navigate = useNavigate();
  const { userInfo } = useCurrentUser();
  const { collapsiblePreferences } = useCollapsibles();
  const { setShowContactQrCode } = useModalsStore();

  const pictureUrl = useMemo(
    () =>
      userInfo?.picture
        ? `${FILE_STORAGE_SERVER_URL}/profile-thumbnail-${userInfo.picture}`
        : "",
    [userInfo]
  );

  return (
    <>
      <motion.div
        initial={{
          opacity: 0,
          width: collapsiblePreferences.navIsCollapsed ? "50px" : "120px",
          height: collapsiblePreferences.navIsCollapsed ? "50px" : "120px",
        }}
        animate={{
          width: collapsiblePreferences.navIsCollapsed ? "50px" : "120px", // ajusta el valor colapsado si necesitas
          height: collapsiblePreferences.navIsCollapsed ? "50px" : "120px", // ajusta el valor colapsado si necesitas
          opacity: 1,
        }}
        className={clsx(["flex", "justify-center", "items-center"])}
        transition={{
          duration: collapsiblePreferences.navIsCollapsed ? 0.2 : 0.2,
          ease: "easeOut",
        }}
        data-tooltip-id={tooltipId}
        data-tooltip-content={isMobile ? "" : "Datos de contacto"}
        data-tooltip-position-strategy="fixed"
        data-tooltip-open-on="hover"
        data-tooltip-offset={0}
      >
        {pictureUrl ? (
          <img
            alt={userInfo?.name}
            className={clsx(
              "!w-full",
              "rounded-md",
              "shadow-md",
              "bg-checkers",
              "object-cover",
              "cursor-pointer",
              "!h-full"
            )}
            src={pictureUrl}
            onClick={() => setShowContactQrCode(true)}
          />
        ) : (
          <div
            className={clsx([
              "w-full",
              "inline-flex",
              "items-center",
              "justify-start",
              "cursor-pointer",
            ])}
            onClick={() => setShowContactQrCode(true)}
          >
            <MdAccountBox
              size={collapsiblePreferences.navIsCollapsed ? 50 : 120}
              className="text-white/50 dark:text-gray-600"
            />
          </div>
        )}
        {!isMobile && (
          <Tooltip
            id={tooltipId}
            style={{ zIndex: 99 }}
            positionStrategy="fixed"
            place="bottom"
          />
        )}
      </motion.div>
    </>
  );
};

export default React.memo(CurrentUserCardInfo);
